/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WriteOnlyTaskType
 */
export interface WriteOnlyTaskType {
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyTaskType
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyTaskType
     */
    clientId?: number;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyTaskType
     */
    category?: WriteOnlyTaskTypeCategoryEnum;
    /**
     * 
     * @type {Date}
     * @memberof WriteOnlyTaskType
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WriteOnlyTaskType
     */
    deletedAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof WriteOnlyTaskType
     */
    repetitionDueDateType?: WriteOnlyTaskTypeRepetitionDueDateTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof WriteOnlyTaskType
     */
    repetitionDueDateValue?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WriteOnlyTaskType
     */
    customizable?: boolean;
}

export function WriteOnlyTaskTypeFromJSON(json: any): WriteOnlyTaskType {
    return WriteOnlyTaskTypeFromJSONTyped(json, false);
}

export function WriteOnlyTaskTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): WriteOnlyTaskType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'clientId': !exists(json, 'client_id') ? undefined : json['client_id'],
        'category': !exists(json, 'category') ? undefined : json['category'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (json['deleted_at'] === null ? null : new Date(json['deleted_at'])),
        'repetitionDueDateType': !exists(json, 'repetition_due_date_type') ? undefined : json['repetition_due_date_type'],
        'repetitionDueDateValue': !exists(json, 'repetition_due_date_value') ? undefined : json['repetition_due_date_value'],
        'customizable': !exists(json, 'customizable') ? undefined : json['customizable'],
    };
}

export function WriteOnlyTaskTypeToJSON(value?: WriteOnlyTaskType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'client_id': value.clientId,
        'category': value.category,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt === null ? null : value.deletedAt.toISOString()),
        'repetition_due_date_type': value.repetitionDueDateType,
        'repetition_due_date_value': value.repetitionDueDateValue,
        'customizable': value.customizable,
    };
}

/**
* @export
* @enum {string}
*/
export enum WriteOnlyTaskTypeCategoryEnum {
    Vehicle = 'vehicle',
    Company = 'company',
    Driver = 'driver',
    Trailer = 'trailer'
}
/**
* @export
* @enum {string}
*/
export enum WriteOnlyTaskTypeRepetitionDueDateTypeEnum {
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year'
}


